export const SET_AUTH_TYPE = 'SET_AUTH_TYPE';
export const SET_USER_PASSWORD = 'SET_USER_PASSWORD';
export const SET_REMAINING_TIME = 'SET_REMAINING_TIME';
export const RESET_USER_PASSWORD = 'RESET_USER_PASSWORD';
